import script from "./TableInvoiceNonPO.vue?vue&type=script&setup=true&lang=js"
export * from "./TableInvoiceNonPO.vue?vue&type=script&setup=true&lang=js"

import "./TableInvoiceNonPO.vue?vue&type=style&index=0&id=2b02cf80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b02cf80"]])

export default __exports__